module.exports = __webpack_public_path__ + "img/icon_guonei.34fbd076.png";